import React, { ReactNode } from 'react';
import { Link as CSLink } from '@cloudscape-design/components';
import { useNavigate, useHref } from 'react-router-dom';

interface LinkProps {
  children: ReactNode;
  to: string;
  external?: boolean;
  onClick?: () => void;
  newTab?: boolean;
  darkBg?: boolean;
}

export const Link = ({
  children,
  to,
  external,
  onClick,
  newTab,
  darkBg,
}: LinkProps) => {
  const navigate = useNavigate();
  const relativeHref = useHref(to, { relative: 'path' });
  return (
    <CSLink
      color={`${darkBg ? 'inverted' : 'normal'}`}
      external={external}
      href={external ? to : undefined}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      onClick={() => {
        onClick?.();
        if (newTab && !external) {
          window.open(relativeHref, '_blank', 'noopener,noreferrer');
        } else if (!external) {
          navigate(`${to}`, { relative: 'path' });
        }
      }}
    >
      {children}
    </CSLink>
  );
};
